import { clearAllPersistedFilters } from './persistentFilters';


export const getUser = () => {
  const userStr = localStorage.getItem('user');
  return userStr ? JSON.parse(userStr) : null;
};

export const getToken = () => {
  return localStorage.getItem('auth_token');
};

export const setAuth = (token, user) => {
  localStorage.setItem('auth_token', token);
  localStorage.setItem('user', JSON.stringify(user));
};

export const clearAuth = () => {
  localStorage.removeItem('auth_token');
  localStorage.removeItem('user');
  localStorage.removeItem('active_company');
  localStorage.removeItem('active_company_id');
  localStorage.removeItem('user_companies');
  clearAllPersistedFilters();
};

export const isAuthenticated = () => {
  return !!getToken();
};

export const isManager = () => {
  const user = getUser();
  return user?.role === 'manager' || user?.role === 'admin';
};

export const isAdmin = () => {
  const user = getUser();
  return user?.role === 'admin';
};

export const isStaff = () => {
  const user = getUser();
  return user?.role === 'staff';
};
